import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  container: ({ maxContentWidth, inset = 0, disableGutters }) => {
    const needsPadding = (maxContentWidth + Number(spacing(inset).replace('px', '')) * 2)
    return {
      marginTop: disableGutters ? 0 : spacing(3),
      [breakpoints.down(needsPadding)]: {
        paddingLeft: spacing(inset),
        paddingRight: spacing(inset)
      }
    }
  },
  content: ({ maxContentWidth }) => ({
    margin: 'auto',
    maxWidth: maxContentWidth
  })
}))
